import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DriverService as CLARADriverService, Driver, InterestedDriver, JourneyInterestedDriver, Vehicle } from '@uzurv/clara';
import { DateFormatConstants, isNullOrUndefined } from '@uzurv/core';
import moment from 'moment-timezone';

@Component({
  selector: 'app-select-driver-list-item',
  templateUrl: './select-driver-list-item.component.html',
  styleUrls: ['./select-driver-list-item.component.scss']
})
export class SelectDriverListItemComponent implements OnChanges {
  @Input()
  interestedDriver: InterestedDriver;

  @Input()
  journeyInterestedDriver: JourneyInterestedDriver;

  @Input()
  isIgnoringProvider = false;

  @Input()
  isWavRide: boolean;

  @Input()
  pickupTime: string;

  @Input()
  timeZone: string;

  @Output()
  interestedDriverSelected: EventEmitter<InterestedDriver> = new EventEmitter();

  @Output()
  journeyInterestedDriverSelected: EventEmitter<JourneyInterestedDriver> = new EventEmitter();

  vehicle: Vehicle;

  constructor(private claraDriverService: CLARADriverService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['interestedDriver']) {
      this.vehicle = isNullOrUndefined(this.interestedDriver)
        ? null
        : this.claraDriverService.getVehicleWithIdForDriver(this.interestedDriver.vehicleId, this.interestedDriver.driver);
    }

    if (changes['journeyInterestedDriver']) {
      this.vehicle = isNullOrUndefined(this.journeyInterestedDriver)
        ? null
        : this.claraDriverService.getVehicleWithIdForDriver(this.journeyInterestedDriver.vehicleId, this.journeyInterestedDriver.driver);
    }
  }

  selectInterestedDriver(): void {
    if (!isNullOrUndefined(this.journeyInterestedDriver)) {
      this.journeyInterestedDriverSelected.emit(this.journeyInterestedDriver);
    } else if (!isNullOrUndefined(this.interestedDriver)) {
      this.interestedDriverSelected.emit(this.interestedDriver);
    }
  }

  get driver(): Driver {
    if (!isNullOrUndefined(this.journeyInterestedDriver)) {
      return this.journeyInterestedDriver.driver;
    }

    if (!isNullOrUndefined(this.interestedDriver)) {
      return this.interestedDriver.driver;
    }

    return null;
  }

  get isProposedTime(): boolean {
    if (isNullOrUndefined(this.interestedDriver)) {
      return false;
    }

    return this.interestedDriver.proposingNewPickupTime;
  }

  get notOnPlatform(): boolean {
    return (
      !isNullOrUndefined(this.interestedDriver) &&
      !isNullOrUndefined(this.interestedDriver.onWavPlatform) &&
      !this.interestedDriver.onWavPlatform
    );
  }

  get selectionText(): string {
    if (this.isWavRide) {
      if (this.isProposedTime) {
        return moment.tz(this.interestedDriver.proposedPickupTime, this.timeZone).format(DateFormatConstants.TIME);
      }
      return this.pickupTime;
    }

    return this.driver?.firstName;
  }
}
